<template>
    <div class="black-subscribe">
        <div class="black-subscribe__row">
            <div class="black-subscribe__img">
                <UiImage
                    style="width: auto; padding: 0; display: block"
                    :path="img"
                    :desktop="{ width: 1016 }"
                    :lazy="false" />
            </div>
            <div class="black-subscribe__content">
                <div>
                    <h1 class="text_15 black-subscribe__title">{{ $t("black_save_to_calendar") }}</h1>
                    <div class="flex black-subscribe__buttons">
                        <a
                            :href="`https://api.v4.post-post-scriptum.com/storage/app/media/secret-sale/event-2026-10.ics?t=${new Date().getTime()}`"
                            class="button button--large button--padding-0-16 text_13">
                            <svg-icon name="plus--xl" width="24" height="24" /> apple
                        </a>
                        <a :href="googleLink" target="_blank" class="button button--large button--padding-0-16 text_13">
                            <svg-icon name="plus--xl" width="24" height="24" /> google
                        </a>
                        <a
                            :href="`https://api.v4.post-post-scriptum.com/storage/app/media/secret-sale/event-2026-10.ics?t=${new Date().getTime()}`"
                            class="button button--large button--padding-0-16 text_13">
                            <svg-icon name="plus--xl" width="24" height="24" /> yandex
                        </a>
                    </div>
                </div>
                <div>
                    <div class="text_15">{{ $t("black_subscribe") }}</div>
                    <form @submit="subscribe" class="black-subscribe__grid">
                        <div class="black-subscribe__cb">
                            <AgreenemtCheckboxses
                                :userSubscribe="userSubscribe"
                                :userSubscribeAd="userSubscribeAd"
                                @update:userSubscribe="userSubscribe = $event"
                                @update:userSubscribeAd="userSubscribeAd = $event"></AgreenemtCheckboxses>
                        </div>
                        <label class="black-subscribe__email" :aria-label="$t('black_email')">
                            <input
                                type="text"
                                :placeholder="$t('black_email')"
                                name="email"
                                class="form-group__input form-group__input--border text_15"
                                v-model="userEmail" />
                        </label>
                        <button
                            class="subscribe__submit button button--dark button--large button--padding-0-16 text_15"
                            type="submit">
                            {{ $t("subscribe_submit") }}
                        </button>
                        <div v-if="userSubscribed" class="black-subscribe__success text_13">
                            {{ $t("black_success_subscribe") }}
                        </div>
                        <div v-if="userSubscribeError" class="black-subscribe__success text_13">
                            {{ $t("black_fail_subscribe") }}<br />
                            {{ userSubscribeError }}
                        </div>
                        <transition name="fade">
                            <div v-if="showErrors" class="text_13" style="color: red">
                                {{ $t("required_all_fields") }}
                            </div>
                        </transition>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UiImage from "@/components/ui/Image.vue";
import AgreenemtCheckboxses from "~/components/form/AgreenemtCheckboxses";
export default {
    name: "SymbiosSubscribe",
    components: { AgreenemtCheckboxses, UiImage },
    async asyncData({ $axios }) {
        try {
            return {
                img: (await $axios.get("/api/page-images/secret-sale-subscribe")).data.img,
            };
        } catch (e) {
            console.log(e);
        }
    },
    data() {
        return {
            userEmail: "",
            userSubscribe: false,
            userSubscribeAd: false,
            userSubscribed: false,
            userSubscribeError: "",
            showErrors: false,
        };
    },
    computed: {
        isShowAgree() {
            return this.$grom.validateEmail(this.userEmail);
        },
        allowSubmit() {
            if (this.isShowAgree && this.userSubscribe && this.userSubscribeAd) {
                return true;
            }
            return false;
        },
        googleLink() {
            let link = " https://www.google.com/calendar/render?";
            const data = [
                "action=TEMPLATE",
                `text=${encodeURIComponent("Ранний доступ к midseason sale")}`,
                "dates=20261027T120000/20261029T235900",
                `details=${encodeURIComponent("Ранний доступ к midseason sale")}`,
                "location=https://post-post-scriptum.com",
            ];
            return link + data.join("&");
        },
    },
    methods: {
        async subscribe(event) {
            event.preventDefault();
            this.showErrors = false;
            this.userSubscribeError = "";
            if (!this.isShowAgree) {
                this.notValidEmail = false;
            }

            if (!this.allowSubmit) {
                this.showErrors = true;
                return;
            }

            let email = this.userEmail.replace(/^\s+|\s+$/g, "");
            try {
                await this.$axios.post("/api/subscribe", {
                    email: email,
                    tags: [this.$route.query.tag || "midsaleoct"],
                    create_promocode: false,
                });
                this.isSended = true;

                (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                    if (window.rrApi) {
                        window.rrApi?.setEmail(email);
                    }
                });

                this.userSubscribed = true;
                this.userSubscribe = false;
                this.userSubscribeAd = false;
            } catch (error) {
                this.userSubscribeError = error;
            }
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", []);
    },
};
</script>
<style lang="less">
.black-subscribe {
    z-index: 1;
    background: #fff;
    &__row {
        display: flex;
        @media @sm {
            flex-direction: column;
        }
    }
    &__img {
        width: ~"min(100%, calc((100vh - 112px) * 2032 / 2709))";
        aspect-ratio: 2032 / 2709;
        flex-shrink: 1;

        picture {
            display: block;
            width: 100%;
            height: 100%;
            opacity: 1 !important;
        }

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        @media @sm {
            width: 100%;
            aspect-ratio: auto;
            height: auto;
            order: 2;

            picture,
            img {
                width: 100%;
                height: auto;
            }
        }
    }
    &__content {
        display: flex;
        padding-left: 64px;
        padding-right: 32px;
        flex-direction: column;
        justify-content: center;
        flex-basis: 680px;
        max-width: 100%;
        @media @sm {
            padding-left: 16px;
            padding-right: 16px;
            flex-direction: column-reverse !important;
            padding-top: 24px;
            flex-basis: auto;
        }
    }
    &__title {
        margin-bottom: 24px;
        @media @sm {
            margin-top: 24px;
        }
    }
    &__buttons {
        gap: 10px;
        margin-bottom: 24px;
        .button {
            gap: 8px;
        }
        @media @sm {
            flex-direction: column;
        }
    }
    &__grid {
        display: grid;
        grid-template-areas: "checkbox checkbox" "email button" "success success";
        grid-template-columns: 287px auto;
        gap: 16px 24px;
        margin-top: 24px;
        place-items: start;

        @media @sm {
            grid-template-areas: "email" "checkbox" "button" "success";
            grid-template-columns: auto;
            padding-bottom: 0;
        }

        .black-subscribe__cb {
            grid-area: checkbox;
            .form-group__label--checkbox {
                margin-top: 0;
                a {
                    white-space: nowrap;
                    @media @sm {
                        white-space: normal;
                    }
                }
            }
        }
        .black-subscribe__email {
            grid-area: email;
            height: 100%;
            width: 100%;
            .form-group__input {
                height: 100%;
                padding-left: 16px;
                height: 48px;
            }
        }
        .subscribe__submit {
            grid-area: button;
            width: auto;
            @media @sm {
                width: 100%;
            }
        }
    }
}
</style>
